import { Controller } from "react-hook-form";
import { ImageUploader } from "@/components/ui";

const MediaStep = ({ control, errors }) => {
    return (
        <div className="space-y-4">
            <Controller
                name="transaction_proof_photo"
                control={control}
                render={({ field }) => (
                    <ImageUploader
                        label="Upload Bukti Transfer"
                        images={field.value}
                        onChange={field.onChange}
                        error={errors.transaction_proof_photo?.message}
                        maxFiles={1}
                    />
                )}
            />
        </div>
    );
};

export default MediaStep;
